import {
  IntensityMetricTypeEnum as IntensityMetric,
  PriorYearSourceEnum as PriorYearSource,
} from '@shared/api/types';
import { z } from 'zod';

export type EmissionRowKey =
  | 'stationaryCombustion'
  | 'mobileCombustion'
  | 'electricity'
  | 'heat'
  | 'businessTravel';

export type CurrentYearData = Record<
  EmissionRowKey,
  { tco2e: number | null; kwh: number | null }
>;

// Handles empty string from controlled inputs → undefined; coerces non-empty to number
const optionalNumber = z.preprocess(
  (v) => (v === '' || v == null ? undefined : Number(v)),
  z.number().optional()
);

const emissionCategorySchema = z.object({
  prevYear: optionalNumber,
  prevYearKwh: optionalNumber,
});

export const secrFormSchema = z.object({
  previousEmissionsSource: z
    .nativeEnum(PriorYearSource)
    .default(PriorYearSource.none),
  intensityMetric: z.nativeEnum(IntensityMetric).optional(),
  prevIntensityValue: optionalNumber,
  currentIntensityValue: optionalNumber,
  stationaryCombustion: emissionCategorySchema,
  mobileCombustion: emissionCategorySchema,
  electricity: emissionCategorySchema,
  heat: emissionCategorySchema,
  businessTravel: emissionCategorySchema,
  methodology: z.string().default(''),
  actionsTaken: z.string().optional(),
});

export type SecrFormValues = z.infer<typeof secrFormSchema>;
export type PrevSource = SecrFormValues['previousEmissionsSource'];

export const DEFAULT_VALUES: SecrFormValues = {
  previousEmissionsSource: PriorYearSource.none,
  intensityMetric: undefined,
  prevIntensityValue: undefined,
  currentIntensityValue: undefined,
  stationaryCombustion: {},
  mobileCombustion: {},
  electricity: {},
  heat: {},
  businessTravel: {},
  methodology: '',
  actionsTaken: '',
};
